import state from './states';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  name: 'eventsShipper',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-order/pages/event-shipper/store/index.js